import { useFormat } from 'helpers/hooks/useFormat';
import { useProductList } from '../../context';

interface Props {
  currentItems: number;
}

const AccumulativeTrace: React.FC<Props> = ({ currentItems }) => {
  const { formatMessage } = useFormat({ name: 'gruenland' });

  const { totalItems } = useProductList();

  return (
    <div className="absolute bottom-[72px] left-1/2 -translate-x-1/2">
      <p>
        {formatMessage({
          id: 'plp.paginationCounter',
          defaultMessage: '{current} prodotti su {total}',
          values: { current: currentItems, total: totalItems },
        })}
      </p>
    </div>
  );
};

export default AccumulativeTrace;
